import { useEffect, useState } from 'react';
import { useProfileImage } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';

export function useAvatar(memberType?: string) {
  const { ready, token } = useKeycloakReady();
  const [avatarUrl, setAvatarUrl] = useState('');

  const { shouldFetch, data, mutate } = useProfileImage(
    {
      name: 'profileImage',
      memberType,
    },
    token ?? '',
    memberType ?? '',
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    },
  );

  useEffect(() => {
    if (data && data.length > 0) {
      if (memberType) {
        const memberPicture = data.filter((r) => r.memberType === memberType).map((r) => r.pictureUrl);
        setAvatarUrl(memberPicture[0] ?? '');
      } else {
        setAvatarUrl(data[0].pictureUrl ?? '');
      }
    } else {
      setAvatarUrl('');
    }
  }, [data, memberType]);

  useEffect(() => {
    setTimeout(() => {
      if (ready && memberType) {
        setAvatarUrl('');
        shouldFetch(true);
      }
    }, 1000);
  }, [ready, memberType, shouldFetch]);

  return { avatarUrl, setAvatarUrl, mutate };
}
